import { FC } from 'react';

import magnifyingGlass from 'assets/brand/mag-glass.png';
import notepadPng from 'assets/brand/notepad.png';
import Button from 'components/_core/Button';
import WorkListEmptyView from 'features/Work/components/WorkListEmptyView';
import { useFilters } from 'features/Work/pages/Catalog/hooks/useFilters';

import locales from './locales';

interface EmptyViewProps {
  onCreateItem: () => void;
  isSearchResult: boolean;
}

const EmptyView: FC<EmptyViewProps> = ({ isSearchResult, onCreateItem }) => {
  const { updateFilters } = useFilters();

  return (
    <WorkListEmptyView
      imageSrc={isSearchResult ? magnifyingGlass : notepadPng}
      title={isSearchResult ? locales.noResult : locales.noItems}
    >
      <Button
        icon="arrow-right"
        marginTop="space-14"
        onClick={() =>
          isSearchResult ? updateFilters({ q: '' }) : onCreateItem()
        }
        variant="inline-primary"
      >
        {isSearchResult ? locales.reset : locales.createItem}
      </Button>
    </WorkListEmptyView>
  );
};

export default EmptyView;
